import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _pt from 'prop-types';
import _URL from '@babel/runtime-corejs3/core-js-stable/url';
import { useCallback, useEffect } from 'react';
import { encode } from 'qss';
import { l as location } from './location-f21dbc25.esm.js';

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
const redirectTo = targetUrl => {
  location.replace(targetUrl);
};
const useRedirector = () => {
  const redirector = useCallback(options => {
    // For now the authentication service runs on the same domain as the application,
    // even on development (using the webpack dev server).
    const originUrl = options.origin ?? window.location.origin;
    const enhancedLocation = options.location || {};
    const searchQuery = _objectSpread(_objectSpread({}, options.queryParams ?? {}), enhancedLocation.query ?? {});
    const targetUrlObject = new _URL(originUrl);
    targetUrlObject.pathname = options.to || targetUrlObject.pathname;
    targetUrlObject.search = `?${encode(searchQuery)}`;
    const targetUrl = targetUrlObject.toString();
    redirectTo(targetUrl);
  }, []);
  return redirector;
};
const Redirector = props => {
  const redirector = useRedirector();
  useEffect(() => {
    redirector(props);
    // Only execute once!
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};
Redirector.propTypes = {
  to: _pt.string.isRequired,
  origin: _pt.string,
  queryParams: _pt.shape({
    redirectTo: _pt.string,
    client_id: _pt.string,
    response_type: _pt.string,
    scope: _pt.string,
    state: _pt.string,
    nonce: _pt.string
  })
};
Redirector.displayName = 'Redirector';

export { Redirector as R, useRedirector as u };
